<template>
  <div class="collectionRequest">
    <main class="list-table mt-5">
      <div class="row">
        <div class="col-md-12">
          <div class="form d-flex align-items-center">
            <p>{{ $t("lostItems.tabs.collectionRequests.text") }}</p>
            <Json2Csv
              class="ml-auto"
              v-if="items.length > 0"
              :json-data="csvData"
              :csv-title="`Lost_Items_Collection_Requests`"
            >
              <button class="btn btn-download">
                {{ $t("lostItems.btnDownload") }}
              </button>
            </Json2Csv>
          </div>
        </div>
      </div>
      <v-client-table
        v-if="items"
        :columns="table_options.columns"
        :options="table_options.options"
        :data="items"
        ref="lostItemsTable"
      >
        <!-- Actions -->

        <template v-slot:dateCollection="props"
          >{{ props.row.formatDate }}, {{ props.row.formatTime }}</template
        >
        <template v-slot:folioAndStatus="props">
          <div class="folio">
            <input
              type="text"
              v-model="props.row.folio"
              v-on:input="assignFolio(props.row, props.index)"
              :placeholder="$t('lostItems.enterFolio')"
            />
            <div class="checkbox">
              <!-- <input
                type="checkbox"
                id="c"
                :disabled="!folio.hasOwnProperty((props.index -1))||folio[props.index -1] === '' || folio[props.index -1] === null"
                @click="openModal(props.row, del=false)"
              />
              <label for="c">
                {{
                $t("lostItems.tabs.collectionRequests.table.checkbox")
                }}
              </label>-->
              <button
                class="btn btn-collected"
                :disabled="
                  !folio.hasOwnProperty(props.index - 1) ||
                    folio[props.index - 1] === '' ||
                    folio[props.index - 1] === null
                "
                @click="openModal(props.row, (del = false))"
              >
                {{ $t("lostItems.tabs.collectionRequests.table.checkbox") }}
              </button>
            </div>
          </div>
        </template>
        <template v-slot:actions="props">
          <div class="actions">
            <!-- Edit -->
            <router-link
              class="edit-btn"
              :to="{
                name: 'Lost Item Detail',
                params: {
                  id: props.row.id,
                  object: props.row
                }
              }"
            >
              <i class="far fa-edit"></i>
            </router-link>
            <!-- Delete -->
            <i
              class="far fa-trash-alt"
              @click="openModal(props.row, (del = true))"
            ></i>

            <!--Detalles
            <i class="fas fa-chevron-right"></i>-->
          </div>
        </template>
      </v-client-table>
    </main>
    <Modal v-if="modalActive" @closeModal="closeModal">
      <template #header>
        <h6 class="modal-title bolded">
          {{ $t("lostItems.tabs.collectionRequests.modal.attention") }}
        </h6>
      </template>
      <template>
        <div class="modal-body-text">
          <p v-if="!isToDelete">
            {{ $t("lostItems.tabs.collectionRequests.modal.body-text-inv") }}
          </p>
          <p v-if="isToDelete">
            {{ $t("lostItems.tabs.collectionRequests.modal.delete-text") }}
          </p>
          <p class="mt-1">
            {{ $t("lostItems.tabs.collectionRequests.modal.body-text2") }}
          </p>
        </div>
      </template>
      <template #footer>
        <div class="controls">
          <span class="control cancel-btn" @click="closeModal">
            {{ $t("map.benefits.list.modal.cancel") }}
          </span>
          <button
            type=" button"
            class="btn control solve-btn"
            v-if="isToDelete"
            @click="deleteItem(itemToDelete)"
          >
            {{ $t("lostItems.tabs.collectionRequests.modal.continue") }}
          </button>
          <button
            type=" button"
            class="btn control solve-btn"
            v-if="!isToDelete"
            @click="updateItem(itemToDelete)"
          >
            {{ $t("lostItems.tabs.collectionRequests.modal.markAsCollected") }}
          </button>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import API_SERVICE from "@/lib/api/lostItems.js";
const api = new API_SERVICE();
const Modal = () => import("@/components/Modal");
import Json2Csv from "vue-json-to-csv";
import moment from "moment";
export default {
  components: {
    Modal,
    Json2Csv
  },
  data() {
    return {
      items: null,
      folio: {},
      page: 0,
      modalActive: false,
      itemToDelete: null,
      isToDelete: false,
      isCollected: {},
      csvData: null,
      dictionary: {
        itemInfo: this.$t(
          "lostItems.tabs.collectionRequests.table.headings.itemInfo"
        ),
        timeCollection: this.$t(
          "lostItems.tabs.collectionRequests.table.headings.timeCollection"
        ),
        dateCollection: this.$t(
          "lostItems.tabs.collectionRequests.table.headings.dateCollection"
        ),
        placeCollection: this.$t(
          "lostItems.tabs.collectionRequests.table.headings.placeCollection"
        ),
        userName: this.$t(
          "lostItems.tabs.collectionRequests.table.headings.userName"
        )
      }
    };
  },
  async beforeMount() {
    await this.getItems();
  },
  methods: {
    getItems: async function() {
      this.$store.commit("global/SET_LOADING", true);
      try {
        let queries = {
          page: this.page,
          limit: 999999,
          published: true,
          status: "waiting_collection"
        };
        const resp = await api.getLostItemsByStatus(queries);

        this.items = resp.result.result;
        this.itemsToDownload();
        for (let index = 0; index < this.items.length; index++) {
          this.items[index].isCollected = false;
          this.items[index].formatDate = moment(
            this.items[index].dateCollection
          ).format("YYYY/MM/DD");
          this.items[index].formatTime = this.items[index].timeCollection;
        }
      } catch (error) {
        console.log(error);
        this.$store.commit("global/SET_LOADING", false);
      } finally {
        this.$store.commit("global/SET_LOADING", false);
      }
    },
    assignFolio: function(value, index) {
      // this.folio = value.folio;
      this.items[index - 1] = value;
      let folio = this.lodash.cloneDeep(this.folio);
      folio[index - 1] = value.folio;
      this.folio = folio;
    },
    openModal: async function(item, del) {
      this.modalActive = true;
      this.isToDelete = del;
      this.itemToDelete = item;
    },
    closeModal: function() {
      this.modalActive = false;
      this.isToDelete = false;
      this.itemToDelete = null;
    },
    deleteItem: async function(item) {
      this.$store.commit("global/SET_LOADING", true);
      try {
        item.published = false;
        item.status = "deleted";
        const response = await api.updateItem(item.id, item);
        await this.getItems();
        this.closeModal();
      } catch (error) {
        console.log(error);
        this.$store.commit("global/SET_LOADING", false);
      } finally {
        this.$store.commit("global/SET_LOADING", false);
        this.closeModal();
        this.itemToDelete = null;
      }
    },
    updateItem: async function(item) {
      const autor = this.$store.getters["session/author"];
      let newDate = new Date();
      let parseDate = moment(newDate).format("YYYY-MM-DD");
      let parseTime = moment(newDate).format("HH:MM");
      let params = {
        status: "collected",
        folio: item.folio,
        collector: autor,
        itemInfo: item.itemInfo,
        dateCollection: parseDate,
        timeCollection: parseTime,
        placeCollection: item.placeCollection
      };

      const response = await api.updateItem(item.id, params);
      await this.getItems();
      this.closeModal();
    },
    itemsToDownload: function() {
      const itemsFields = [
        "itemInfo",
        "dateCollection",
        "timeCollection",
        "placeCollection",
        "userName"
      ];

      let downloadArray = this.items.map(item => {
        let obj = {};
        itemsFields.forEach(field => {
          obj[this._translateHeader(field)] = item[field];
        });
        // for (const key in item) {
        //   obj[this._translateHeader(key)] = item[key];
        // }
        return obj;
      });
      this.csvData = downloadArray;
    },
    _translateHeader(header) {
      if (this.dictionary.hasOwnProperty(header)) {
        return this.dictionary[header];
      }
      return header;
    }
  },
  computed: {
    table_options: function() {
      return {
        columns: [
          "itemInfo",
          "dateCollection",
          "placeCollection",
          "userName",
          "folioAndStatus",
          "actions"
        ],
        options: {
          texts: {
            filter: `${this.$t("components.vue_tables.filter")}:`,
            filterPlaceholder: this.$t("components.vue_tables.filter_ph")
          },
          headings: {
            itemInfo: this.$t(
              "lostItems.tabs.collectionRequests.table.headings.itemInfo"
            ),
            dateCollection: this.$t(
              "lostItems.tabs.collectionRequests.table.headings.dateCollection"
            ),
            placeCollection: this.$t(
              "lostItems.tabs.collectionRequests.table.headings.placeCollection"
            ),
            userName: this.$t(
              "lostItems.tabs.collectionRequests.table.headings.userName"
            ),
            folioAndStatus: this.$t(
              "lostItems.tabs.collectionRequests.table.headings.folioAndStatus"
            ),
            actions: this.$t(
              "lostItems.tabs.collectionRequests.table.headings.actions"
            )
          },
          sortable: [
            "itemInfo",
            "dateCollection",
            "placeCollection",
            "userName"
          ],
          filterable: ["itemInfo"],
          resizableColumns: false,
          sortIcon: {
            base: "fas",
            up: "fa-sort-up",
            down: "fa-sort-down",
            is: "fa-sort"
          },
          perPage: 10,
          columnsClasses: {
            itemInfo: "itemInfo-col",
            dateCollection: "dateCollection-col",
            placeCollection: "placeCollection-col",
            userName: "userName-col",
            folioAndStatus: "folioAndStatus-col",
            actions: "actions-col"
          }
        }
      };
    },
    appLang: function() {
      return this.$store.getters["settings/currentLang"];
    }
  }
};
</script>

<style lang="scss" scoped>
.actions {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.actions > * {
  cursor: pointer;
}
.actions > .edit-btn {
  color: $black;
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  &:hover {
    color: $black;
  }
}
</style>
<style>
.form-inline label {
  display: initial;
}
.folio {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.folio input {
  width: 100% !important;
}

.collectionRequest .modal-container {
  max-width: 30vw !important;
  max-height: 60vh !important;
}
.collectionRequest .modal-container .controls {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: end;
}
.bolded {
  font-weight: bold !important;
}
.controls span {
  cursor: pointer;
}
.controls span:hover {
  text-decoration: underline;
}
.btn-download {
  background: #000 !important;
  color: #fff !important;
  border-radius: 0px !important;
}
.btn-collected {
  background: #000 !important;
  color: #fff !important;
  border-radius: 0px !important;
  height: 50px;
  width: 100%;
  margin-top: 1rem !important;
}

td {
  text-align: left !important;
  vertical-align: middle !important;
}

#VueTables_th--itemInfo {
  width: 15% !important;
}
#VueTables_th--dateCollection {
  width: 20% !important;
}
#VueTables_th--placeCollection {
  width: 15% !important;
}
#VueTables_th--userName {
  width: 15% !important;
}
#VueTables_th--folioAndStatus {
  width: 20% !important;
}
#VueTables_th--actions {
  width: 10% !important;
}
.VueTables__search {
  width: 100%;
}
.VueTables__search-field {
  width: 25%;
}
</style>
